import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';
import { LayoutService } from '../../../services/layout/layout.service';
import { NavbarSearchCustomersDataService } from '../../../services/navbar-search-customers/navbar-search-customers.data.service';
import { SidebarRightService } from '../../../services/sidebar-right/sidebar-right.service';

@Component({
  selector: 'app-nav-menu-bottom',
  templateUrl: './nav-menu-bottom.component.html',
})
export class NavMenuBottomComponent {

  overSuraIcon: boolean = false;

  @Output() menuClick = new EventEmitter<void>();

  @Input() isCollapsed: boolean = false;

  classTab: string = `w-full inline-flex flex-col gap-2 grow
    justify-center items-center self-stretch
    transition ease-in-out duration-200
    select-none cursor-pointer
    border-[#161618]
    hover:text-[#CCB613] hover:border-[#CCB613]
    border-b-2 pt-2
  `;

  constructor(
    public chatBotV2DS: ChatBotV2DataService,
    public navbarSearchCustomersDS: NavbarSearchCustomersDataService,
    public el: ElementRef,
    public router: Router,
    public sidebarRightS: SidebarRightService,
    layoutService: LayoutService,
  ) {
    layoutService.addComponentHeight(el);
  }

}
